import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import { ReactNode } from 'react'

interface RegularSectionProps {
    children?: ReactNode
    'aria-label'?: string
    [key: string]: any
}

const Index = (props: RegularSectionProps) => {
    const { children, ...rest } = props
    const isDev = process.env.NODE_ENV === 'development'
    return (
        <Box
            component={'section'}
            aria-label={rest['aria-label']}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                position: 'relative',
                flexGrow: 1,
                gap: 3,
                px: { xs: 2, md: 4, lg: 10 },
                py: { xs: 1, md: 2, lg: 4 },
              }}
        >
            {isDev && (
                <Box width={'100%'}>
                    <Divider textAlign='left'>
                        <Typography
                            variant='caption'
                            color='inherit'
                        >
                            {rest['aria-label']}
                        </Typography>
                    </Divider>
                </Box>
            )}
            {children}
        </Box>
    )
}

export default Index


